var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPepole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.421326,
    y: 0.590088,
    width: 76,
    height: 76,
    rx: 25,
    fill: "#DBEAFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0047 19.7292C49.1475 20.4165 50.093 21.3879 50.7493 22.5488C51.4056 23.7097 51.7504 25.0206 51.7501 26.3542C51.7504 27.6877 51.4056 28.9987 50.7493 30.1596C50.093 31.3205 49.1475 32.2918 48.0047 32.9792M60.5834 58.375V57.05C60.5834 52.1033 60.5834 49.63 59.6206 47.7397C58.7737 46.0776 57.4224 44.7264 55.7604 43.8795M32.9792 34.0833C33.9943 34.0833 34.9993 33.8834 35.9371 33.495C36.8748 33.1066 37.7269 32.5372 38.4446 31.8195C39.1623 31.1018 39.7316 30.2497 40.1201 29.312C40.5085 28.3742 40.7084 27.3692 40.7084 26.3542C40.7084 25.3392 40.5085 24.3341 40.1201 23.3963C39.7316 22.4586 39.1623 21.6065 38.4446 20.8888C37.7269 20.1711 36.8748 19.6018 35.9371 19.2133C34.9993 18.8249 33.9943 18.625 32.9792 18.625C30.9293 18.625 28.9634 19.4393 27.5139 20.8888C26.0644 22.3383 25.2501 24.3043 25.2501 26.3542C25.2501 28.4041 26.0644 30.37 27.5139 31.8195C28.9634 33.269 30.9293 34.0833 32.9792 34.0833ZM16.4167 57.05V58.375H49.5417V57.05C49.5417 52.1033 49.5417 49.63 48.5789 47.7397C47.732 46.0776 46.3808 44.7264 44.7187 43.8795C42.8284 42.9167 40.3551 42.9167 35.4084 42.9167H30.5501C25.6034 42.9167 23.1301 42.9167 21.2397 43.8795C19.5777 44.7264 18.2265 46.0776 17.3796 47.7397C16.4167 49.63 16.4167 52.1033 16.4167 57.05Z",
    stroke: "#2B57FB",
    strokeWidth: 1.93422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPepole);
export default __webpack_public_path__ + "static/media/Pepole.36dc4b886909551f1362eafac0e7d8bc.svg";
export { ForwardRef as ReactComponent };